export default __webpack_public_path__ + "static/media/Teste.85ef002b.svg";